module.exports = __webpack_public_path__ + "static/media/noImage.417b62f1.png";